var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @desc ordinal scale
 */
import LinearScale from './linear';
import { templateRich } from '../utils/template';
import * as lodash from '../utils/lodash';
import { isRichFormat } from '../rich';
/**
 * linear scale
 */
var OrdinalScale = /** @class */ (function (_super) {
    __extends(OrdinalScale, _super);
    function OrdinalScale(categories, min, max, start, end) {
        var _this = _super.call(this, min, max, start, end) || this;
        _this.type = 'ordinal';
        _this.categories = categories;
        return _this;
    }
    OrdinalScale.prototype.setCategoryies = function (categories) {
        this.categories = categories;
    };
    OrdinalScale.prototype.scale = function (value, indexMode) {
        if (!indexMode) {
            return _super.prototype.scale.call(this, value);
        }
        var index = this.categories.indexOf(value);
        return _super.prototype.scale.call(this, index);
    };
    OrdinalScale.prototype.getLabel = function (input) {
        var index = Math.round(input);
        var value = this.categories[index];
        var isFirst = index === 0;
        var intervalWidth = Math.abs(this.end - this.start) / (this.max - this.min);
        var isLast = index === this.categories.length - 1;
        if (lodash.isString(this.formatter) || isRichFormat(this.formatter)) {
            return templateRich(this.formatter, { value: value, index: index, isFirst: isFirst, isLast: isLast, intervalWidth: intervalWidth });
        }
        if (lodash.isFunction(this.formatter)) {
            return this.formatter(value, index, { isFirst: isFirst, isLast: isLast, intervalWidth: intervalWidth });
        }
        return value;
    };
    OrdinalScale.prototype.niceTicks = function () {
        // nothing to do
    };
    OrdinalScale.prototype.getTicks = function () {
        var ticks = [];
        var min = Math.round(this.min);
        // between -0.5 and -5.5, [0, 1, 2, 3, 4, 5]
        var max = Math.round(this.max - 0.5);
        for (var i = min; i <= max; i++) {
            ticks.push(i);
        }
        return ticks;
    };
    return OrdinalScale;
}(LinearScale));
export default OrdinalScale;
